import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useFilterFormTemplateStore } from "presentation/stores/use-filter-form-template-store";
import FormEdit from "../../FormEdit";
import { Toast } from "primereact/toast";

type Props = {
  refetch: () => void;
};

const HeaderManageFormsGrid: React.FC<Props> = ({
  refetch,
}) => {
  const [showModal, setShowModal] =
    useState<boolean>(false);
    const toast = useRef<Toast>(null);
    const [globalFilterValue, setGlobalFilterValue] = useState<string>("");
    const { filters, setFilters, resetFilters } = useFilterFormTemplateStore();
    const [currentGuid, setCurrentGuid] =
    useState<string | null>(null);

  const addFormTemplate = () => {
    setCurrentGuid(null);
    setShowModal(true);
  };

   const clearFilter = () => {
    resetFilters();
    setGlobalFilterValue("");
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      let _filters = { ...filters };
      // @ts-ignore
      _filters["query"].value = globalFilterValue;
      setFilters(_filters);
    }
  };

  const showToastSuccess = (detail: string) => {
      toast.current?.show({ severity: "success", summary: "Sucesso", detail, life: 1500 });
  };

  const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGlobalFilterValue(e.target.value);
  };
  
  useEffect(() => {
    if (filters.query.value !== globalFilterValue) {
      setGlobalFilterValue(filters.query.value);
    }
  }, [filters]);
  return (
    
     <div className="flex justify-content-between">
      <Dialog
        header="Criar Formulário"
        visible={showModal}
        onHide={() => setShowModal(false)}
        style={{
            width: "70vw",
            height: "90vh",
        }}
        contentStyle={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            height: "100%",
        }}
      >
        <FormEdit
          guid={currentGuid}
          refetchGrid={() => {
            refetch();
          }}
          onCloseSuccess={() => {
            setShowModal(false);
            showToastSuccess("Formulário criado com sucesso");

          }}
          onClose={() => {setShowModal(false)}}
        />
      </Dialog>
         <div>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            onKeyDown={onKeyDown}
            placeholder="Procurar"
          />
        </IconField>
      </div>
      <div style={{ display: "flex" }}>
        <Button
          type="button"
          icon="pi pi-plus"
          label="Criar Formulário"
          outlined
          onClick={
            addFormTemplate
          }
          style={{
            backgroundColor:
              "#2196f3",
            color: "white",
            borderRadius: "8px",
          }}
        />
       <div style={{ width: "10px" }} />
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Limpar"
          outlined
          onClick={
            clearFilter
          }
          style={{
            backgroundColor:
              "white",
            borderColor:
              "#2196f3",
            color: "#2196f3",
            borderRadius: "8px",
          }}
        />
        </div>
          <Toast ref={toast} />
        </div>

  );
};

export default HeaderManageFormsGrid;